import React from 'react';
import FileUploader from '../components/fileuploader';
import { API_BASE_URL } from '../config';

const UploadTest = () =>
{
  // Define any state or data that needs to be passed to the FileUploader.
  const apiEndpoint = 'http://localhost:7299/api/Media'; // Replace with your actual API endpoint
  const businessId = 91; // Example businessId, this should come from your data
  const userType = 'businessreview'; // Specify user type as needed

  return (
    <div>
      <h3>Business Review - File Uploader</h3>
      {/* Use the FileUploader component */}
      <FileUploader apiEndpoint={apiEndpoint} businessUserId={businessId} userType={userType} />
    </div>
  );
};

export default UploadTest;
